export default "__VITE_ASSET__daed2ad5__"